import styled from 'styled-components'
import palette from '../../../../theme/palette'

export const Textarea = styled.div<{ colorScheme?: string, withBackground?: boolean }>`
  width: 100%;
  position: relative;
  color: ${({ theme, colorScheme, withBackground }) => withBackground ? theme.colorScheme[`${colorScheme}`].surface.text.base.negative : 'black'};

  textarea {
    -webkit-appearance: none;
    appearance: none;
    width: 100%;
    min-height: ${({ theme }) => theme.rem(200)};
    border: none;
    background-color: ${palette.grayscale[100]};
    border-radius: ${({ theme }) => theme.rem(16)};
    ${({ theme }) => theme.typo('buttonMD')};
    padding: ${({ theme }) => theme.rem(24)};
    resize: vertical;
    font-family: inherit;
    color: ${({ theme, colorScheme, withBackground }) => withBackground ? theme.colorScheme[`${colorScheme}`].surface.text.base.negative : 'black'};

    &:focus {
      &::placeholder {
        opacity: 0;
      }
    }
  }
`

export const TextareaError = styled.div`
  padding-top: ${({ theme }) => theme.rem(8)};
  color: ${({ theme }) => theme.colors.status.error.default};
  font-size: ${({ theme }) => theme.rem(12)};
`
